export default {

  // ------------------ 订阅管理页面开始 ----------------------------
  "subscribe_manager_title": "Subscription Management",
  "subscribe_manager_subscribe_reports": "Dashboard",
  "subscribe_manager_push_title": "Push Title",
  "subscribe_manager_last_push_time": "Latest Push Date",
  "subscribe_manager_push_result": "Push Status",
  "subscribe_manager_push_method": "Push Channel",
  "subscribe_manager_push_frequency": "Frequency",
  "subscribe_manager_current_state": "Current Status",
  "subscribe_manager_handle": "Operation",
  "subscribe_record_receivers": "Recipients",
  "subscribe_record_send_status": "Push Status",
  "subscribe_record_last_push_time": "Push Date",
  "subscribe_record_push_history": "Push History",

  "subscribe_manager_push_result_not": "Not Yet Begun",
  "subscribe_manager_push_result_fail": "Failed",
  "subscribe_manager_push_result_success": "Successed",
  "subscribe_manager_push_result_part_success": "Partially Successed",
  "subscribe_manager_push_result_pushing": "In Progress",
  "subscribe_manager_push_in_queue": "In Progress", // 对应后端返回的 队列中
  "subscribe_manager_push_result_fail_info": "Detail",

  "subscribe_manager_push_method_invalid": "Invalid",
  "subscribe_manager_push_method_email": "Email",
  "subscribe_manager_push_method_weixin": "WeCom",

  "subscribe_manager_current_state_subscribing": "Subscribed",
  "subscribe_manager_current_state_unsubscribed": "Unsubscribed",
  "subscribe_manager_current_state_finished": "End",
  "subscribe_manager_current_state_failure": "Deleted",

  "subscribe_manager_handle_unsubscribe": "Unsubscribe",
  "subscribe_manager_handle_push_again": "Resend",
  "subscribe_manager_handle_push_report": "History",
  "subscribe_manager_handle_resubscribe": "Re-subscribe",

  "subscribe_manager_handle_is_push_again": "Are you sure to send again",
  "subscribe_manager_handle_is_unsubscribe": "Are you sure to unsubscribed",
  "subscribe_manager_handle_is_delete": "After deletion, all recipients will no longer receive push dashboard. Are you sure to delete the subscription about {name}?",
  "subscribe_manager_search": "Search Dashboard or Push Title",

  // 推送频率文本
  "subscribe_manager_frequency_invalid": "Invalid",
  "subscribe_manager_frequency_push_now": "Send Now",
  "subscribe_manager_frequency_single": "Single",

  "subscribe_manager_frequency_everyday": "Daily",
  "subscribe_manager_frequency_every": "Weekly",
  "subscribe_manager_frequency_every_month": "Monthly",
  "subscribe_manager_frequency_day": "Day",

  "subscribe_manager_success": " Success",
  "subscribe_manager_fail": " Fail",

  // ------------------ 订阅管理页面结束 ----------------------------

  'subscribe_manager_page': 'Subscription Center',
  'subscribe_setting_save_success': 'Subscribe successfully.',
  'subscribe_setting_save_success1': 'Subscribe successfully. You can go to ',
  'subscribe_setting_save_success2': 'to see the status of pushing dashboard.',
  'subscribe_setting_save_fail': 'Subscription failed.',
  'subscribe_setting_title': 'Subscription Setting',
  'subscribe_setting_input_label_page': 'Current Subscription',
  'subscribe_setting_input_label_out_email': 'Subscribe to external email',
  'subscribe_setting_input_label_out_email_placeholder': 'Enter recipient email(s) manually, separated by ";"',
  'subscribe_setting_confirm_send_out_email': 'Content may contain sensitive information. Confirm sending to external email?',
  'subscribe_setting_btn_sennd_modal_confirm': 'Confirmation',
  'subscribe_setting_input_page_des': 'Due to size limitation of the screen, only the tables currently displayed on the screen will be visible after subscription.',
  'subscribe_setting_input_label_receiver': 'Recipients',
  'subscribe_setting_input_placeholder_receiver': 'Please enter recipients',
  'subscribe_setting_input_empty_receiver': 'Recipients must be filled in',
  'subscribe_setting_input_label_title': 'Push Title',
  'subscribe_setting_input_placeholder_title': 'Please fill in the title',
  'subscribe_setting_input_empty_title': 'Push Title must be filled in',
  'subscribe_setting_input_label_content': 'Additional text',
  'subscribe_setting_input_placeholder_content': 'Please fill in additional text  to introduce the pushing dashboard  (A maximum of 1000 characters is allowed.)',
  'subscribe_setting_input_error_content': 'Content must not exceed 1000 characters',
  'subscribe_setting_input_label_ways': 'Push Channel',
  'subscribe_setting_input_empty_ways': 'Push Channel must be filled in',
  'subscribe_setting_input_label_now': 'Send Now',
  'subscribe_setting_input_label_one': 'Single',
  'subscribe_setting_input_label_hour': 'Hourly',
  'subscribe_setting_input_label_day': 'Daily',
  'subscribe_setting_input_label_week': 'Weekly',
  'subscribe_setting_input_label_month': 'Monthly',
  'subscribe_setting_input_label_ways_email': 'Email',
  'subscribe_setting_input_label_ways_wechat': 'WeCom',
  'subscribe_setting_input_label_frequency': 'Frequency',
  'subscribe_setting_input_placeholder_frequency': 'Please select date',
  'subscribe_setting_input_empty_frequency': 'Frequency must be filled in',
  'subscribe_setting_input_label_circle': 'Subscription Period',
  'subscribe_setting_range_time_day': 'Day',
  'subscribe_setting_range_time_text': 'Enter Date',

  'subscribe_setting_btn_save': 'Save',
  'subscribe_setting_btn_preview': 'Preview',
  'subscribe_setting_btn_test': 'Test ',
  'subscribe_setting_test_title': 'Send Test Email',
  'subscribe_setting_btn_confirm': 'Confirm',
  'subscribe_setting_btn_cancel': 'Cancel',

  'subscribe_setting_prevew_fail_msg': 'Preview failed as there is no path for the preview image to be returned.',
  'subscribe_setting_prevew_fail': 'Preview Fail',
  'subscribe_setting_un-subscribe_success': 'Unsubscription Unsubscribe Successful',
  'subscribe_setting_un-subscribe_success-content': 'You have been successfully removed from this subscriber list and will not receive any further reports for this specific game.',
  'subscribe_setting_un-subscribe_fail': 'Unsubscription Failed',
  'subscribe_setting_un-subscribe_fail_content': 'Please contact {name} for further assistance.',
  'subscribe_setting_viewport_width': 'Page Width',
  'subscribe_setting_viewport_width_placeholder': 'Please enter the screenshot page width, default is 2600',
  'subscribe_batch_add': 'Batch Add',
  'subscribe_account_type': "Account Type",
  'subscribe_username': "Username",
  'subscribe_batch_add_placeholder': 'Please use ";" or newline to separate multiple users',
  'subscribe_enter_valid_email': 'Please enter a valid email',
  'subscribe_email_not_exist': 'Email does not exist',
  'subscribe_username_not_exist': 'Username does not exist',
  'subscribe_username_invalid': 'Username invalid',

};
